<template>
    <div class="modal-overlay" v-if="createUser">
      <div class="create-user">
        <div class="section-header">
          <h3>Create New user</h3>
        </div>
        <div class="section-body">
          <div class="picture">
            <form enctype="multipart/form-data" novalidate>
              <div class="dropbox default" :class="{'error': errors.userAvatar}">
                <input
                  type="file"
                  @change="
                    filesChange($event.target.files);
                    fileCount = $event.target.files.length;
                  "
                  accept="image/*"
                  class="input-file"
                />
                <img v-if="preivewUrl != ''" id="preview" :src="preivewUrl" />
                <img class="default-img" v-if="preivewUrl == ''" id="preview" src="../../assets/add_photo.png" />
              </div>
              <p class="pic-message">User Picture *</p>
            </form>
          </div>
          <div class="user-details">
            <div class="whole-name">
              <div class="name">
                <label>First Name *</label>
                <input
                  type="text"
                  v-model="user.firstName"
                  placeholder="First name"
                  :class="{ error: errors.userFirstName }"
                />
              </div>
              <div class="name">
                <label>Last Name *</label>
                <input
                  type="text"
                  v-model="user.lastName"
                  placeholder="Last name"
                  :class="{ error: errors.userLastName }"
                />
              </div>
            </div>
            <div class="user-item">
              <label>Bio *</label>
              <textarea
                v-model="user.bio"
                placeholder="Biography"
                :class="{ error: errors.userBio }"
              ></textarea>
            </div>
            <div class="user-row">
              <div class="user-item age">
                <label>Age *</label>
                <input type="number"
                :class="{ error: errors.userAge }"
                 v-model="user.age" placeholder="Age">
              </div>
              <div class="user-item gender">
                <label>Gender *</label>
                <select
                  v-model="user.gender"
                  :class="{ error: errors.userGender }"
                >
                  <option value="" disabled>Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="user-item location">
                <label>Location *</label>
                <select
                  v-model="user.location"
                  :class="{ error: errors.userLocation }"
                >
                  <option value="" disabled>Location</option>
                  <option v-for="country in countries" :value="country" :key="country">{{ country }}</option>
                </select>
              </div>
            </div>
            <div class="user-item strength">
              <label>Strength *</label>
              <select
                v-model="user.strength"
                :class="{ error: errors.userStrength }"
              >
                <option value="" disabled>Strength</option>
                <option value="weak">Weak</option>
                <option value="average">Average</option>
                <option value="strong">Strong</option>
                <option value="very_strong">Very Strong</option>
              </select>
            </div>
            <div class="buttons">
              <button class="secondary-btn-dark" @click="createUser = false">
                DISCARD
              </button>
              <button @click="saveUser()" class="primary-btn">
                CREATE USER
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { COUNTRIES } from '@/constants';
import { createUser } from "@/api/requests";

export default {
  name: "UserModal",

  data() {
    return {
      avatarToUpload: [],
      preivewUrl: "",
      user: {
        email: "",
        firstName: "",
        lastName: "",
        gender: "",
        birthday: "",
        location: "United Kingdom",
        age: "",
        bio: "",
        strength: "average",
      },
      errors: {
        userAvatar: false,
        userEmail: false,
        userFirstName: false,
        userLastName: false,
        userGender: false,
        userAge: false,
        userStrength: false,
        userLocation: false,
        userBio: false,
      },
    }
  },

  methods: {
    filesChange(fileList) {
      this.preivewUrl = URL.createObjectURL(fileList[0]);
      this.avatarToUpload = [fileList[0]];
    },

    randomDate(start, end) {
      return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    },

    saveUser() {
      if (this.validateUser()) {
        let today = new Date();
        today.setFullYear(today.getFullYear() - this.user.age);
        const firstDay = new Date(today.getFullYear(), 0, 1);
        const lastDay = new Date(today.getFullYear(), 11, 31);

        let userPayload = {
          email: `test.${this.user.firstName}.${this.user.lastName}@wotive.com`.toLowerCase(),
          first_name: this.user.firstName,
          last_name: this.user.lastName,
          gender: this.user.gender,
          birthday: this.randomDate(firstDay, lastDay),
          location: this.user.location,
          strength: this.user.strength,
          bio: this.user.bio,
        };

        let formData = new FormData();
        for (var key in userPayload) {
          formData.append(key, userPayload[key]);
        }
        formData.append(
          "avatar",
          this.avatarToUpload[0],
          this.avatarToUpload[0].name
        );

        createUser(formData)
          .then((response) => {
            let payload = {
              id: response.data.id,
              first_name: userPayload.first_name,
              last_name: userPayload.last_name,
              last_post: null,
              bio: userPayload.bio,
              birthday: userPayload.birthday,
              image: this.preivewUrl,
            };
            this.users.push(payload);
            this.user = {
              email: "",
              firstName: "",
              lastName: "",
              gender: "male",
              birthday: "",
              location: "",
              bio: "",
            };
            this.preivewUrl = "";
            this.avatarToUpload = [];
            this.selectedUserId = response.data.id;
            this.createUser = false;
          })
          .catch(() => {
            // TODO errors
          });
      }
    },

    validateUser() {
      this.errors = {
        userAvatar: false,
        userFirstName: false,
        userLastName: false,
        userGender: false,
        userLocation: false,
        userBio: false,
        userAge: false,
        userStrength: false,
      };
      let valid = true;
      if (this.avatarToUpload.length == 0) {
        this.errors.userAvatar = true;
        valid = false;
      }
      if (this.user.firstName == "") {
        this.errors.userFirstName = true;
        valid = false;
      }
      if (this.user.lastName == "") {
        this.errors.userLastName = true;
        valid = false;
      }
      if (this.user.gender == "") {
        this.errors.userGender = true;
        valid = false;
      }
      if (this.user.age == "") {
        this.errors.userAge = true;
        valid = false;
      }
      if (this.user.strength == "") {
        this.errors.userStrength = true;
        valid = false;
      }
      if (this.user.location == "") {
        this.errors.userLocation = true;
        valid = false;
      }
      if (this.user.bio == "") {
        this.errors.userBio = true;
        valid = false;
      }

      return valid;
    },
  },

  computed: {
    countries() {
      return COUNTRIES;
    },


    createUser: {
      get () {
        return this.$store.state.activity.createUser
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'createUser'})
      }
    },

    users: {
      get () {
        return this.$store.state.activity.users
      },
      set (value) {
        this.$store.commit('activity/addUser', value);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .create-user {
    background: $sec0;
    width: 50%;
    margin-left: 25%;
    margin-top: 150px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);
    padding: $spacing-base;

    .section-body {
      margin-top: $spacing-base;
    }

    h3 {
      margin: 0;
      padding: 0;
      color: $sec6;
      text-transform: uppercase;
    }
    
    .picture {
      height: 80px;
    }

    .user-details {
      clear: both;
      margin-top: $spacing-base;
      label {
        color: $sec5;
        font-weight: 500;
        font-size: 14px;
        padding-bottom: 4px;
      }
      .whole-name {
        display: flex;
        gap: $spacing_base;
        margin-bottom: $spacing-base;
        .name {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }
      .user-row {
        display: flex;
        flex-direction: row;
        gap: $spacing-base;
        margin-top: $spacing-base;
      }
      .user-item {
        display: flex;
        flex-direction: column;
      }
      .age {
        input {
          width: 80px;
        }
      }
      .gender {
        flex: 2;
      }
      .location {
        flex: 3;
      }
    }
    .strength {
      width: 50%;
      margin-top: $spacing-base;
    }

    input {
      background: $dark;
      color: $sec2;
    }

    textarea {
      background: $dark;
      color: $sec2;
    }

    select {
      background-color: $dark;
      color: $sec2;
    }
  }
}

.default {
  float: left;
  .default-img {
    width: 20px;
    height: 20px;
    border-radius: 200px;
    padding: 30px;
    background: $dark;
  }
}

</style>